import { Component, OnInit, computed, signal, HostListener, OnDestroy, ChangeDetectorRef, inject } from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../services/authorization.service';
import { TokenService } from '../../services/token.service';
import { UserLoggedInModel } from '../../models/authen.model';
import { Function } from '../../enums/authorization';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
  collapsed = signal(false);
  screenWidth = 0;
  sidenavWidth = computed(() => this.collapsed() ? '65px': '300px');
  mobileMenuToggled = signal(false);

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  userLoggedIn: UserLoggedInModel;
  isMobile = false;
  FN_HO_SO_CA_NHAN: string;
  constructor(
    private authenticationService: AuthenticationService,
     private authorizationService: AuthorizationService,
     private tokenService: TokenService, 
    private router: Router
  ) {
    const changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher);

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit(): void {
    this.FN_HO_SO_CA_NHAN = Function.A_C_PROFILE;
    if(this.tokenService.isAuthentication){
      this.userLoggedIn = JSON.parse(this.tokenService.getUserData());
     
    } 
  }

  onToggleSideNav(data : any):void {
    this.mobileMenuToggled.set(data);
  }
  onLogout(){
    this.authenticationService.logout().subscribe({
      next: (response) => {
        this.router.navigate(['pub/login']);             
      }
    });  
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  public hasPermission(functionName: string): boolean {
    return this.authorizationService.isAuthorizationByPerm(functionName);
  }

}
